// @ts-nocheck
import React, { useEffect, useMemo } from 'react';
import DataTableWidget from './DataTableWidget';
import API from '../../services/ApiInstance';
import ApiRoutes from '../../services/ApiRoutes';
import { ReportTableDefaultSettings } from './widgets-default-settings';
import PropTypes from 'prop-types';
import { PERMISSIONS } from '../../constants';
import { toast } from 'react-toastify';
import { getReportsWithPagination } from '../../services/WidgetDataService';
import { useTableColumns } from '../../context/TableColumnsContext';
import useAuthorization from '../../hooks/useAuthorisationManager';

function ReportsTableWidget({ settings }) {
  const { hasPermission } = useAuthorization();
  const { reportTableColumns, reportTableColumnsExpanded } = useTableColumns();

  const canDeactivateReport = hasPermission(PERMISSIONS.Report.Update);

  const deactivateReport = async (report) => {
    if (report) {
      const url = `${ApiRoutes.deactivateReport}?id=${report.id}`;
      await API.deleteReport(url);
      toast.success('Report deleted');
    }
  };

  const getAIData = async (recordId) => {
    const params = new URLSearchParams({
      recordId: recordId,
    });
    try {
      const response = await API.get(
        `${ApiRoutes.aiOutPutsByReport}?${params.toString()}`
      );
      return response;
    } catch (error) {
      console.error('getAiOutPutHazards error:', error);
      throw error;
    }
  };

  return (
    <DataTableWidget
      columns={reportTableColumns}
      columnsExpanded={reportTableColumnsExpanded}
      settings={settings}
      defaultSettings={ReportTableDefaultSettings}
      url={ApiRoutes.getReportExtras}
      dataFetchFunc={getReportsWithPagination}
      canDeleteRecord={canDeactivateReport}
      deleteFunc={deactivateReport}
      getAiOutPutFunc={getAIData}
      entityName="report"
    />
  );
}

ReportsTableWidget.propTypes = {
  settings: PropTypes.object,
};

export default ReportsTableWidget;
